import React from 'react';
import { HtmlOutlined } from '@mui/icons-material';
import { Html, HtmlPropsSchema } from './Html';
import HtmlSidebarPanel from './HtmlSidebarPanel';
export default {
    label: 'Html',
    icon: React.createElement(HtmlOutlined, null),
    type: 'Html',
    defaultData: {
        props: { contents: 'Raw <strong>HTML</strong> Content' },
        style: {
            fontSize: 16,
            textAlign: null,
            padding: { top: 16, bottom: 16, left: 24, right: 24 },
        },
    },
    SidebarPanel: HtmlSidebarPanel,
    Component: Html,
    schema: HtmlPropsSchema,
};
//# sourceMappingURL=index.js.map